import getSelectedPaymentCategory
from '../../selectors/PaymentOptionSelectors/ApmExperimentSelectors/getSelectedPaymentCategory';
import getIndexOfNextAvailablePaymentOption
from '../../selectors/PaymentOptionSelectors/getIndexOfNextAvailablePaymentOption';
import getIndexOfNextAvailablePaymentOptionForSelectedCategory
from '../../selectors/PaymentOptionSelectors/getIndexOfNextAvailablePaymentOptionForSelectedCategory';
import getIsSelectedPaymentOptionAvailable
from '../../selectors/PaymentOptionSelectors/getIsSelectedPaymentOptionAvailable';
import getIsSelectedPaymentOptionInSelectedCategory
from '../../selectors/PaymentOptionSelectors/getIsSelectedPaymentOptionInSelectedCategory';
import getNonHiddenPaymentOptionsForSelectedCategory
from '../../selectors/PaymentOptionSelectors/getNonHiddenPaymentOptionsForSelectedCategory';
import {getSelectedPaymentOptionIndex} from '../../selectors/PaymentOptionSelectors/getSelectedPaymentOptionIndex';
import {changeSelectedPaymentMethod} from './PaymentSelectionActions';

const isValidIndex = index => (!!index || index === 0) && index > -1;

export default (ignoreSelectedCategory = false) => (dispatch, getState) => {
  const selectedCategory = getSelectedPaymentCategory(getState());
  const isSelectedPaymentOptionInSelectedCategory = getIsSelectedPaymentOptionInSelectedCategory(getState());
  const shouldIgnoreSelectedCategory = ignoreSelectedCategory && !isSelectedPaymentOptionInSelectedCategory;
  const paymentOptionsForSelectedCategory = getNonHiddenPaymentOptionsForSelectedCategory(getState());
  
  let nextAvailableIndex = getIndexOfNextAvailablePaymentOption(getState());
  
  // If no payment options available for selected payment category use the first available option regardless of its category
  // ie use return value of getIndexOfNextAvailablePaymentOption()
  if (!shouldIgnoreSelectedCategory && paymentOptionsForSelectedCategory?.length && paymentOptionsForSelectedCategory?.length > 0) {
    const isSelectedPaymentOptionAvailable = getIsSelectedPaymentOptionAvailable(getState());

    // This ensures that if a category and payment option belonging to that category is selected it is persisted on page refresh
    // but only is it is not hidden and not disabled
    if (isSelectedPaymentOptionInSelectedCategory && isSelectedPaymentOptionAvailable) {
      nextAvailableIndex = getSelectedPaymentOptionIndex(getState());
    } else {
      const nextAvailablePaymentOptionForSelectedCategory = getIndexOfNextAvailablePaymentOptionForSelectedCategory(getState());
      
      // This ensures that if a category is selected and has available options, one of those options is selected
      // If not, set selectedPaymentOptionIndex to -1
      if (isValidIndex(nextAvailablePaymentOptionForSelectedCategory)) {
        nextAvailableIndex = nextAvailablePaymentOptionForSelectedCategory;
      } else {
        nextAvailableIndex = -1;
      }
    }
  }
  
  if (isValidIndex(nextAvailableIndex)) {
    return dispatch(changeSelectedPaymentMethod(nextAvailableIndex, 'selectAvailablePaymentOption', false, selectedCategory));
  }
  
  return dispatch(changeSelectedPaymentMethod(-1, 'selectAvailablePaymentOption'));
};
